type Env = 'dev' | 'uat' | 'qa' | 'prod';
type EnvUrls = Record<Env, { base: string; portal: string }>;

let env: Env = 'dev';
const rawFile = new XMLHttpRequest();
rawFile.open('GET', 'assets/env.json', false);
rawFile.onreadystatechange = () => {
  if (rawFile.readyState === 4) {
    if (rawFile.status === 200 || rawFile.status === 0) {
      try {
        const parsed = JSON.parse(rawFile.responseText);
        env = parsed?.env ?? 'dev';
      } catch {
        env = 'dev';
      }
    }
  }
};
rawFile.send(null);

const urls: EnvUrls = {
  dev: {
    base: 'https://ecaapxfac.fmr.com',
    portal: 'https://fidelityprimedev.fmr.com/fcmprimeportal-rest/dispatch',
  },
  uat: {
    base: 'https://ecaapxfac.fidelity.com',
    portal: 'https://fidelityprime-preprod.fidelity.com/fcmprimeportal-rest/dispatch',
  },
  qa: {
    base: 'https://ecaapxfac.fmr.com',
    portal: 'https://fidelityprimeqa.fmr.com/fcmprimeportal-rest/dispatch',
  },
  prod: {
    base: 'https://ecaap.fidelityprime.com',
    portal: 'https://www.fidelityprime.com/fcmprimeportal-rest/dispatch',
  },
};

const envKey = urls[env] ? env : 'dev';

export const constants = {
  baseUrl: urls[envKey].base,
  appId: 'PRIMESRVPORTAL',
  appName: 'AP010025-Prime Portal',
  fsreqid: 'REQ',
  portalUrl: urls[envKey].portal,
  pwdAuthStatusCode: {
    success: 1200,
    blocked1: 1203,
    expired: 1205,
    blocked2: 1401,
    callbacksRequired: 1202,
    invalidCredentials: 1403,
  },
  sessionStatusCode: {
    success: 1200,
    success2: 1201,
    AuthNotCompleted: 1201,
    callbacksRequired: 1202,
    blocked: 1401,
    accessProhibited: 1403,
    logout: 204,
  },
  OTP_TEXT_TEMPLATE:
    'Your security code is: $$CODE$$. DO NOT SHARE THIS CODE WITH ANYONE. Enter it online to complete your transaction. Thank you.',
  OTP_VOICE_TEMPLATE:
    'Hello, this is a message from Fidelity Investments with your security code.  Your code is $$CODE$$.  Once again, your code is $$CODE$$.  Goodbye.',
  ECAAP_REQUEST_HEADERS: {
    TOKEN_TYPE: 'ET',
    POST_TOKEN_LOCATION: 'PAYLOAD',
    GET_TOKEN_LOCATION: 'HEADER',
    TOKEN_LOCATION: 'HEADER',
    ACCEPT_TOKEN_LOCATION: 'PAYLOAD',
  },
  SERVICING_SIGNIN_URL: '/servicing/signin',
  ECAAP_URLS: {
    USERNAME: '/user/identity/username',
    SESSION_LOGIN: '/user/session/login',
    ATTRIBUTES: '/user/identity/attributes',
    OTP_SMS: '/user/factor/otp/sms/authentication',
    OTP_VOICE: '/user/factor/otp/voice/authentication',
    OTP_EMAIL: '/user/factor/otp/email/authentication',
    OTP_REP: '/user/factor/otp/rep/authentication',
    PASSWORD_STATUS: '/user/factor/password/status',
    PASSWORD_ENROLL: '/user/factor/password/enrollment',
    PASSWORD_AUTHENTICATE: '/user/factor/password/authentication',
  },
  LOGGING_URL: '/servicing/logs/collector',
  BLOCKED_CHARS_REGEX: '/[#&*{}[]]/',
  DELIVERY_OPTION: {
    call: 'CALL',
    text: 'TEXT',
    email: 'EMAIL',
    rep: 'REP',
  },
  HTTP_CODE: {
    OK: 200,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    SYSTEM_ERROR: 500,
    FORBIDDEN: 403,
  },
  ECAAP_AUTHENTICATORS: {
    SMS: 'OTP-SMS',
    VOICE: 'OTP-VOICE',
    EMAIL: 'OTP-EMAIL',
  },
  PASSWORD_STATE_CREATE: 'CREATE',
  PASSWORD_RESET_STEPS: {
    ChannelSelectionStep: 0,
    DeliverySelectionStep: 1,
    TextMsgChallengeStep: 2,
    CallChallengeStep: 3,
    EmailChallengeStep: 4,
    FidelityRepHelpLineStep: 5,
    FromFidelityRepChallengeStep: 6,
  },
};

export function generateRandomString(length: number, chars: string) {
  let mask = '';
  if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz';
  if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  if (chars.indexOf('#') > -1) mask += '0123456789';
  if (chars.indexOf('!') > -1) mask += '~`!@#$%^&*()_+-={}[]:";\'<>?,./|\\';
  let result = '';
  for (let i = length; i > 0; --i) result += mask[Math.round(Math.random() * (mask.length - 1))];
  return result;
}
